import { createSlice, Dispatch } from '@reduxjs/toolkit';
import { fetchVirtualAiStagingOrders } from 'apis';

const initialState = {
  orders: [],
  onGoingOrders: [],
  onGoingIterations: {},
  iterationOrOrderOngoing: false,
};

export const aiStagingOrderSlice = createSlice({
  name: 'aiStagingOrder',
  initialState,
  reducers: {
    initialize: (state) => {
      state.orders = null;
      state.onGoingOrders = [];
      state.onGoingIterations = {};
      state.iterationOrOrderOngoing = false;
    },
    setOrders: (state, action) => {
      state.orders = action.payload;
    },
    setOnGoingOrders: (state, action) => {
      state.onGoingOrders = action.payload;
    },
    setOnGoingIterations: (state, action) => {
      state.onGoingIterations = action.payload;
    },
    setIterationOrOrderOngoing: (state, action) => {
      state.iterationOrOrderOngoing = action.payload;
    },
  },
});

// Actions
export const {
  initialize,
  setOrders,
  setOnGoingOrders,
  setOnGoingIterations,
  setIterationOrOrderOngoing,
} = aiStagingOrderSlice.actions;

export const fetchAiStagingOrder = (token: string, listing_id: number) => {
  return async (dispatch: Dispatch) => {
    const data = await fetchVirtualAiStagingOrders(token, listing_id);
    if (data) {
      const { orders, onGoingOrders, onGoingIterations, iterationOrOrderOngoing } = data;
      dispatch(setOrders(orders));
      dispatch(setOnGoingOrders(onGoingOrders));
      dispatch(setOnGoingIterations(onGoingIterations));
      dispatch(setIterationOrOrderOngoing(iterationOrOrderOngoing));
    }
  };
};

export default aiStagingOrderSlice.reducer;
